import { render, staticRenderFns } from "./EVMMetadata.vue?vue&type=template&id=19b2d672&scoped=true&"
import script from "./EVMMetadata.vue?vue&type=script&lang=ts&"
export * from "./EVMMetadata.vue?vue&type=script&lang=ts&"
import style0 from "./EVMMetadata.vue?vue&type=style&index=0&id=19b2d672&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b2d672",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
